export default {
  // Search
  batchSn: 'Batch No.',
  batchSnPlaceholder: 'Enter batch number',
  codeSn: 'Serial No.',
  codeSnPlaceholder: 'Enter serial number',
  productName: 'Product Name',
  productNamePlaceholder: 'Enter product name',
  memberId: 'User ID',
  memberIdPlaceholder: 'Enter user ID',
  memberName: 'Nickname',
  memberNamePlaceholder: 'Enter nickname',
  region: 'Scan Country/Region',
  regionPlaceholder: 'Please select',
  isRepetition: 'Scan Count',
  isRepetitionPlaceholder: 'Please select',
  firstScan: 'First',
  repeatedScan: 'Repeated',
  qrcodeType: 'QR Code Type',
  qrcodeTypePlaceholder: 'Please select',
  qrcodeTypeBig: 'Large Label',
  qrcodeTypeMid: 'Medium Label',
  qrcodeTypeSmall: 'Small Label',
  qrcodeTypeAntiFake: 'Anti-Fake',
  scanTime: 'Scan Time',
  startTime: 'Start Time',
  endTime: 'End Time',
  colBatchNo: 'QR code batch',
  // Actions
  export: 'Export',
  // Table columns
  colQrcode: 'QR Code',
  colScanCount: 'Scan Count',
  colUserInfo: 'User Info',
  colProductInfo: 'Product Info',
  colScanTime: 'Scan Time',
  colScanRegion: 'Scan Region',
  colScanIp: 'Scan IP',
  // Scan count
  nthScan: 'No. {count}',
  // Empty state
  emptyText: 'No scan records',
  maxDateRange: 'Date range cannot exceed 6 months',
};
